export default __webpack_public_path__ + "static/404_grafika-c3b131c9eb6f47fd5e770a047668d2c4.png";